<template>
    <div>
        <div v-if="$root.account_makes_payments && !useAuthStore().isLoggedIn && $root.needsLogin" class="box">
            <account-verification-warning @verify-account="$root.go('v2.account.verify')" />
        </div>

        <incomplete-account-notice-view />

        <network-connect-reminder location="dashboard" />

        <tasks-summary-banner />

        <div v-if="hasAnythingInProgress">
            <div v-if="$root.deals.length">
                <div class="box">
                    <div class="campaign-form-title">Your Partnerships</div>
                </div>

                <deal-list />
            </div>

            <div v-if="$root.campaigns_in_progress.length || $root.briefs.length">
                <div v-if="!featureResponsiveDashboard" class="box">
                    <div class="campaign-form-title">Your Campaigns</div>
                </div>

                <campaign-list />
            </div>
        </div>

        <div v-else>
            <blank-state>
                <div slot="title" class="mb-10">No Current Campaigns</div>

                <div slot="content">
                    Hey! Right now we don't have anything available, but we will soon!

                    <span v-if="$root.account.support_email" data-testid="contact-support">
                        If you need help or have any questions you can email us at
                        <a :href="`mailto:${$root.account.support_email}?subject=Influencer%20Program%20Sponsorships`">
                            {{ $root.account.support_email }}
                        </a>
                    </span>
                </div>
            </blank-state>
        </div>
    </div>
</template>

<script>
    import { onMounted } from 'vue-demi';
    import { message } from '@grininc/grin-ui';
    import DealList from './deal/DealList.vue';
    import CampaignList from './campaign/CampaignList.vue';
    import AccountVerificationWarning from '../../../app-v2/components/data-views/dashboard/partials/AccountVerificationWarning.vue';
    import TasksSummaryBanner from '../../../app-v2/components/data-views/dashboard/partials/TasksSummaryBanner.vue';
    import IncompleteAccountNoticeView from '../../../app-v2/components/data-views/dashboard/IncompleteAccountNoticeView.vue';
    import { useFeatureFlagsStore, useAuthStore } from '../../../stores';
    import NetworkConnectReminder from './networks/NetworkConnectReminder.vue';
    import useRoute from '../../composables/use-route';

    export default {
        name: 'Sponsorships',

        components: {
            DealList,
            CampaignList,
            AccountVerificationWarning,
            IncompleteAccountNoticeView,
            NetworkConnectReminder,
            TasksSummaryBanner
        },

        data() {
            const flags = useFeatureFlagsStore().data;

            return {
                featureResponsiveDashboard: flags['live-site-responsive-dashboard'] || false,
                useAuthStore
            };
        },

        computed: {
            hasAnythingInProgress() {
                return this.$root.campaigns_in_progress.length || this.$root.deals.length || this.$root.briefs.length;
            },

            hasOnlySingleDeal() {
                return (
                    this.$root.deals.length === 1 &&
                    !this.$root.campaigns_in_progress.length &&
                    !this.$root.briefs.length
                );
            },

            hasOnlySingleCampaign() {
                return (
                    this.$root.campaigns_in_progress.length === 1 &&
                    !this.$root.deals.length &&
                    !this.$root.briefs.length
                );
            }
        },

        /**
         * When the component is created
         */
        created() {
            if (this.hasOnlySingleCampaign) {
                this.$root.showCampaign(this.$root.campaigns_in_progress[0].id);
            } else if (this.hasOnlySingleDeal) {
                this.$root.showDeal(this.$root.deals[0].id);
            }
        },

        setup() {
            const showLiveSiteSwitchedMessage = () => {
                const route = useRoute();

                if (route.get()?.query?.switched) {
                    message.success(`Switched to ${route.get()?.query?.switched}.`);
                    route.removeQueryParam('switched');
                }
            };

            onMounted(() => {
                showLiveSiteSwitchedMessage();
            });
        }
    };
</script>

<style lang="scss" scoped>
    .box {
        padding-top: $g-spacing-5;
        padding-bottom: 0;
    }
</style>
